export const normalizeInviteCode = (inviteCode?: string | null) => {
  const normalizedInviteCode = inviteCode?.trim()
  return normalizedInviteCode ? normalizedInviteCode : null
}
